import { Config } from "./config";
export var WHO_AM_I_CHITRA_DATA = "WHO_AM_I_CHITRA_DATA";
export var ChitraToken = "CHITRA_TOKEN";
export var CSRFToken = "CSRF_TOKEN";
export var whoamiUrl = "".concat(Config.baseURL, "whoami");
export var ChitraTokenUrl = "".concat(Config.baseURL, "ProductApp/GetToken");
export var fileterKeyUrl = "".concat(Config.baseURL, "ProductApp/FilterKey");
export var Permalink = "".concat(Config.baseURL, "ProductApp/GetPermalink");
export var PermalinkNew = "".concat(Config.baseURL, "ProductApp/GetPermalinkNew");
export var IframeUrl = function (permalink) { return "".concat(Config.CHITRA_ENDPOINT, "/superset/dashboard/p/").concat(permalink, "/?expand_filters=0"); };
